import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftBig = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "white",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M35.0625 45L20 29.9375L35.0625 14.875L37.75 17.5625L25.375 29.9375L37.75 42.3125L35.0625 45Z" })
});
export default SvgArrowLeftBig;
